import ErrorHandler from "./error-handling";
import FallbackComponent from "./fallback-component";

export const FallbackComponents = FallbackComponent;
export default ErrorHandler;
